import { PAYMENT_STEP } from '~/constants/application/health-insurance-v2'

// Routes where Optimizely must not be loaded (PCI DSS compliance)
export const PAYMENT_ROUTE_PATTERNS = [
  '/health-insurance/application/payment',
  `/health-insurance/applicationV2/${PAYMENT_STEP}`
]

export function isPaymentRoute (path: string): boolean {
  return PAYMENT_ROUTE_PATTERNS.some(route => path.startsWith(route))
}
